import { mapState } from 'vuex';
import store from '../store';
import initProductSearch from '../productSeach';
import { first } from 'rxjs/operators';
import PerfectScrollbar from 'perfect-scrollbar';
import cartItemListMixin from "../vue_mixins/cartItemListMixin";
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

window.headerVm = new Vue({
    el: '#header',
    store,
    mixins: [cartItemListMixin],
    components: {
        VuePerfectScrollbar
    },
    computed: {
        ...mapState({
            allProducts: state => state.allProducts,
        }),
        orderItemsCount() {
            return this.sessionOrder ? this.sessionOrder.order_items.length : 0;
        }
    },
    created() {
        this.$store.dispatch('getAllProducts');
    },
});

/**
 * initialize product search function in header and sideNav
 */
window.headerVm.$watchAsObservable('allProducts').pipe(
    first(({newValue}) => newValue !== null)
)
.subscribe(() => {
    initProductSearch(document.getElementById("header-search-input"), window.headerVm.allProducts);
    initProductSearch(document.getElementById("slideout-menu-search-input"), window.headerVm.allProducts);
});

$(document).ready(() => {

    const wishListFloatingBoxProductList = $('.nav-functions .floating-box.wish-list-floating-box .product-list');

    if(wishListFloatingBoxProductList.length > 0) {
        new PerfectScrollbar(wishListFloatingBoxProductList[0], {
            wheelPropagation: false
        });
    }

})